export const isBigInt = (value: unknown): value is bigint => typeof value === "bigint"
